import { ExamEventStatusButtonGroup } from '@exam-center/exam-event-management';
import {
  Button,
  Collapse,
  ExpandMoreRoundedIcon,
  FilterListOutlinedIcon,
  Flex,
  Rotate,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { ProctoringExamEventScheduleForm } from '../../components';
import { useExamEventScheduleSearchParams } from '../../hooks';

export default function ProctoringExamEventScheduleFilters() {
  const [{ status }, { changeStatus }] = useExamEventScheduleSearchParams();

  const [isExpand, { toggle }] = useDisclosure(false);

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(4),
      })}
    >
      <Flex sx={{ justifyContent: 'space-between', width: '100%' }}>
        <ExamEventStatusButtonGroup value={status} onChange={changeStatus} />
        <Button
          variant='outlined'
          color='secondary'
          startIcon={<FilterListOutlinedIcon />}
          endIcon={
            <Rotate in={isExpand}>
              <ExpandMoreRoundedIcon />
            </Rotate>
          }
          onClick={toggle}
        >
          Filter
        </Button>
      </Flex>
      <Collapse in={isExpand} unmountOnExit>
        <ProctoringExamEventScheduleForm />
      </Collapse>
    </Flex>
  );
}
